export default function hasIntegration(slug, currentCompany) {
  if (
    currentCompany?.integrations.find(
      (integration) => integration.slug === slug
    )
  )
    return true;
  return false;
}
